module.exports = __webpack_public_path__ + "img/kaist_gallery9.72686001.jpg";